export default __webpack_public_path__ + "static/media/nintendo.a909be56.svg";